import { render, staticRenderFns } from "./PushAllUserNotification.vue?vue&type=template&id=5d90b592&scoped=true&"
import script from "./PushAllUserNotification.vue?vue&type=script&lang=js&"
export * from "./PushAllUserNotification.vue?vue&type=script&lang=js&"
import style0 from "./PushAllUserNotification.vue?vue&type=style&index=0&id=5d90b592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90b592",
  null
  
)

export default component.exports